import { Container, Separator, TextDisplay, Video, Wrapper } from "src/styled";

import UnderConstructionVideo from "src/assets/videos/under_construction.mp4";
import { translate } from "src/services";
import { Image } from "src/styled";

import RubiconLogo from "src/assets/svg/RubiLogoBlack.svg";

const UnderConstructionPage = () => {
  return (
    <Container>
      <Wrapper textAlign="center" maxWidth="400px">
        <Video
          src={UnderConstructionVideo}
          autoPlay
          datatype="video/mp4"
          loop
          muted
        />
      </Wrapper>
      <TextDisplay size="xxxLarge" align="center" block>
        {translate("underConstructionPage.title")}
      </TextDisplay>
      <TextDisplay margin="large" size="xLarge" align="center" block>
        {translate("underConstructionPage.description")}
      </TextDisplay>
      <Separator height={50} />
      <TextDisplay margin="large no small" size="medium" align="center" block>
        {translate("common.poweredBy")}
      </TextDisplay>
      <Wrapper alignItems="center" maxWidth="200px">
        <Image src={RubiconLogo} />
      </Wrapper>
    </Container>
  );
};

export default UnderConstructionPage;
